import { getDatasetInfo } from '../utils/dataset-graph.js';

/**
 * Retrieves the database status
 * @param {Object} filter - An object containing query filters (unused)
 * @param {string} endpoint - The SPARQL endpoint to connect to
 * @returns {Object} - An object containing database status information
 */
export async function getDbStatus(filter, endpoint = 'https://lod.humanatlas.io/sparql') {
  if (!filter.sessionToken) {
    const results = {
      status: 'Ready',
      message: 'Database successfully loaded',
      checkback: 3600000,
      loadTime: 22594,
      timestamp: new Date().toISOString(),
    };
    return results;
  } else {
    return await getDatasetInfo(filter.sessionToken, endpoint);
  }
}
